import React from 'react';
import { ConfirmDialog } from 'swag-client-common/components/info/confirm-dialog';
export function ConfirmCreateMyInventoryPopupComponent({
  onCancel,
  onConfirm
}) {
  return /*#__PURE__*/React.createElement(ConfirmDialog, {
    open: true,
    onConfirm: onConfirm,
    onCancel: onCancel,
    onClose: onCancel,
    title: "Create My Inventory",
    msg: "Are you sure you want to create your own inventory and add products to it? You will have to accept our Terms of Service to proceed."
  });
}